
<template>
  <div class="legal-mention">
    <div class="container" :class="{active: show}" v-if="!loading">
      <span>{{ data.upTitleLegal }}</span>
      <h1>{{ data.titleLegal }}</h1>
      <div class="description" v-html="data.descriptionLegal" />
    </div>
  </div>
</template>

<script>
import { LEGAL } from '../queries'
import { useQuery, useResult } from '@vue/apollo-composable'
import { useShowTimeout } from '../compositions/useShowTimeout'
import { watch, ref } from '@vue/composition-api'

export default {
  name: 'LeagalMention',
  head: {
    title: {
      inner: 'Legal Mention | OriginalFake Photography | 2020 | Paris - FRANCE'
    },
  },
  setup() {
    const { result, loading } = useQuery(LEGAL)
    const data = useResult(result, null, data => data.siteGeneralSettings.legal)
    const show = loading.value ? ref(false) : useShowTimeout(1000)

    watch(loading, (newVal, oldVal) => {
      if (!newVal && oldVal) setTimeout(() =>  show.value = true, 500)
    })

    return  {
      show,
      loading,
      data
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    @extend %container;

    margin-top: 8rem;
  }

  span {
    @extend %font-regular;
    line-height: 0.4rem;
    font-size: 0.4rem;
    letter-spacing: 0.5rem;
    transition: opacity 0.8s $ease-out, letter-spacing 1s $ease-out;
    opacity: 0;

    .active & {
      opacity: 1;
      letter-spacing: 0.2rem;
    }
  }

  h1 {
    @extend %font-bold;

    font-size: 3rem;
    line-height: 2.5rem;
    opacity: 0;
    color: $red;
    margin-bottom: 1rem;
      
    letter-spacing: 0.5rem;
    transition: opacity 0.8s 0.4s $ease-out, letter-spacing 1s 0.4s $ease-out;

    .active & {
      opacity: 1;
      letter-spacing: 0;
    }
  }

  .description {
    margin-bottom: 1rem;
    opacity: 0;
    transition: opacity 0.8s 1s $ease-out;

    .active & {
      opacity: 1;
    }
  }
</style>
